
export default {
  formActions: {
    'addPlaceInput': 'Añadir campo',
    'clearRoute': 'Limpiar ruta',
    'reverseRoute': 'Invertir ruta',
    'roundTrip': 'Ruta circular',
    'toggleRoundTrip': 'Cambiar ruta circular',
    'showDangerousAreas': 'Zonas peligrosas'
  }
}
